import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Home } from "./pages/Home";
import { Report } from "./pages/Report";
import { ReportConfirmation } from "./pages/ReportConfirmation";
import { StatusCheck } from "./pages/StatusCheck";
import { STAFF_ROLES, MANAGE_ROLES } from "./lib/auth";

// Staff-only pages are code-split out of the public bundle — church members
// filling out /report on their phone shouldn't have to download the admin
// panel (which pulls in a QR-code library) or the dashboard just to submit
// an incident.
const StaffLogin = lazy(() => import("./pages/StaffLogin").then((m) => ({ default: m.StaffLogin })));
const StaffDashboard = lazy(() => import("./pages/StaffDashboard").then((m) => ({ default: m.StaffDashboard })));
const IncidentDetail = lazy(() => import("./pages/IncidentDetail").then((m) => ({ default: m.IncidentDetail })));
const MyAccount = lazy(() => import("./pages/MyAccount").then((m) => ({ default: m.MyAccount })));
const Admin = lazy(() => import("./pages/Admin").then((m) => ({ default: m.Admin })));
const Reports = lazy(() => import("./pages/Reports").then((m) => ({ default: m.Reports })));

function StaffPageLoading() {
  return (
    <div className="container">
      <p>Loading…</p>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/report" element={<Report />} />
          <Route path="/report/confirmation" element={<ReportConfirmation />} />
          <Route path="/status" element={<StatusCheck />} />
          <Route
            path="/staff/login"
            element={
              <Suspense fallback={<StaffPageLoading />}>
                <StaffLogin />
              </Suspense>
            }
          />
          <Route
            path="/staff"
            element={
              <ProtectedRoute roles={STAFF_ROLES}>
                <Suspense fallback={<StaffPageLoading />}>
                  <StaffDashboard />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="/staff/incidents/:id"
            element={
              <ProtectedRoute roles={STAFF_ROLES}>
                <Suspense fallback={<StaffPageLoading />}>
                  <IncidentDetail />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="/staff/account"
            element={
              <ProtectedRoute roles={STAFF_ROLES}>
                <Suspense fallback={<StaffPageLoading />}>
                  <MyAccount />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="/staff/reports"
            element={
              <ProtectedRoute roles={STAFF_ROLES}>
                <Suspense fallback={<StaffPageLoading />}>
                  <Reports />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="/staff/admin"
            element={
              <ProtectedRoute roles={MANAGE_ROLES}>
                <Suspense fallback={<StaffPageLoading />}>
                  <Admin />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

function NotFound() {
  return (
    <div className="container">
      <div className="card">
        <h2>Page not found</h2>
        <p>The page you're looking for doesn't exist.</p>
        <a className="btn btn-primary" href="/">
          Return home
        </a>
      </div>
    </div>
  );
}
